import React from 'react'
import { useController, useFormContext } from 'react-hook-form'

import { ToolConfig } from 'data/hooks/agents/types'

import { Checkbox } from 'ui/components/Checkbox/Checkbox'
import { Field } from 'ui/components/Field'

import { ConfigureToolProps } from './types'

export function ConfigureDataAnalysisTool({}: ConfigureToolProps) {
    const { control } = useFormContext<ToolConfig>()
    const { field } = useController({
        name: 'supplied_settings.return_raw_query_results',
        control,
    })

    const rawValue = typeof field.value === 'string' ? field.value : undefined
    const returnRawResults = rawValue?.toLowerCase() === 'true'

    return (
        <Field label="Settings">
            <Checkbox
                checked={returnRawResults}
                onCheckedChange={(checked) => field.onChange(checked ? 'true' : 'false')}
                helperText="Return the result records without additional processing"
            >
                Return raw results
            </Checkbox>
        </Field>
    )
}
